export default "__VITE_ASSET__b5820bf9__"